module.exports = __webpack_public_path__ + "static/img/identImg.4edbc47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/identImg.png
// module id = 185
// module chunks = 1